@if (!isBeltEmpty()) {
  <div class="datatable-belt" [class.datatable-belt-compact-mode]="isCompactModeActivated()">
    <button
      mat-button
      (click)="onClickBelt()"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      (mouseover)="onMouseOver()"
      (mouseout)="onMouseOut()"
    >
      @if (belt()?.maximalLength) {
        {{ belt()?.maximalLength }} cm
      }
      @if (!belt()?.maximalLength && belt()?.length) {
        {{ belt()?.length }}Ø
      }
      - {{ belt()?.shape }}
    </button>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen()"
    >
      <mat-card class="datatable-belt__card">
        <mat-card-content>
          <vectronic-belt-info [belt]="belt()" />
        </mat-card-content>
      </mat-card>
    </ng-template>
  </div>
}
